const api = '/api/v1/copyItem.php';
import axios from 'axios';
export const copyItemRepository =  {
    methods: {
        async copy(data){
            return  axios.post(api,data);
        },
        async getItem(data){
            return  axios.post('/api/v1/copy.php',{'USER_ID':data});
        },
        async checkCopy(data){
            return  axios.post('/api/v1/checkCopy.php',data);
        }
        
    }
};

